import React from "react";

export default function Button({
  as: Component = "button",
  className = "",
  children,
  ...props
}) {
  return (
    <Component className={className} {...props}>
      {children}
    </Component>
  );
}
